module.exports = __webpack_public_path__ + "images/4cfba7754d020b516f3ce13479114afb.png";